import React from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { Tabs, message, Modal, Button, Checkbox } from 'antd'

import { fetchCloudAccounts } from '../../actions/cloud-accounts-actions'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'

import PricingModal from '../../components/PricingModal'

import Filter from './filter'
import Overview from './overview'
import S3 from './s3'
import Database from './database'
import Compute from './compute'
import DownloadInvoice from './download-invoice'

import './styles.scss'
import moment from 'moment'

const { TabPane } = Tabs

class Analytics extends React.Component {
  constructor(props) {
    super(props)

    const { user } = this.props
    this.hasAccess =
      user.packages && user.packages.map(p => p.title).includes('Analytics')

    const month = (moment().get('month') + 1).toString()
    this.state = {
      selectedCloud: null,
      billingBucket: null,
      selectedDate: {
        year: moment()
          .year()
          .toString(),
        month: month.length === 1 ? `0${month}` : month,
      },
      page: 'overview',
      overview: {
        loading: false,
        computeCost: { value: null, error: null },
        storageCost: { value: null, error: null },
        totalCost: { value: null, error: null },
        forecast: { value: null, error: null },
        totalCostChart: {
          data: [],
          error: null,
        },
        servicesUsage: [],
        costlyTransfers: [],
      },
      s3: {
        loading: false,
        error: false,
        s3: { size: null, cost: null },
        efs: { size: null, cost: null },
        transfer: { size: null, cost: null },
      },
      database: {
        loading: false,
        error: false,
        total: { size: null, cost: null },
        running: null,
        stopped: null,
      },
      compute: {
        loading: false,
        error: false,
        total: { size: null, cost: null },
        running: null,
        stopped: null,
      },
      downloadInvoice: {
        loading: false,
      },
    }
  }

  componentDidMount() {
    const { fetchCloudAccounts } = this.props
    fetchCloudAccounts()
    this.loadData()
  }

  loadOverviewData = (selectedCloud, month) => {
    const to = moment(month)
      .endOf('month')
      .toISOString()
    Promise.all([
      CloudFlyerAPI.analytics.overview(selectedCloud, month),
      CloudFlyerAPI.transfer.migration.usage(month, to),
      CloudFlyerAPI.transfer.migration.history('top', 0, 50),
    ])
      .then(([overviewResp, usageResp, historyResp]) => {
        const overviewData = overviewResp.data
        const usageData = usageResp.data
        let historyData = historyResp.data

        let computeCost,
          storageCost,
          totalCost,
          forecast,
          totalCostDetails = null
        if (overviewData.categories) {
          const compute = overviewData.categories.filter(
            cat => cat.name === 'Compute'
          )[0]
          const storage = overviewData.categories.filter(
            cat => cat.name === 'Storage'
          )[0]
          if (compute) computeCost = compute['monthly_actual']
          if (storage) storageCost = storage['monthly_actual']

          const costsSum = overviewData.categories
            .map(cat => cat.monthly_actual)
            .reduce((a, b) => a + b, 0)
          totalCostDetails = overviewData.categories.map(cat => {
            return {
              value: cat.monthly_actual,
              name: cat.name,
              percent: `${((cat.monthly_actual / costsSum) * 100).toFixed(2)}%`,
              cost: `$ ${cat.monthly_actual.toFixed(2)}`,
              products: cat.products,
            }
          })
        }
        totalCost = overviewData.monthly_actual
        forecast = overviewData.monthly_forecast

        // services usage

        const quota = this.props.user.quota.c2c.total
        const num = usageData['usage']

        const newUsageData = {
          name: usageData['service'],
          num: num,
          numOf: quota,
          percent: (num / quota) * 100,
        }

        // top costly transfers
        historyData = historyData
          .filter(item => item.hasOwnProperty('cost'))
          .map(item => {
            return {
              amount: item.cost,
              size: item.size,
              date: item.ended,
              via: item.cloud,
            }
          })
          .slice(0, 5)

        // set state
        this.setState({
          ...this.state,
          overview: {
            ...this.state.overview,
            computeCost: { value: computeCost },
            storageCost: { value: storageCost },
            totalCost: { value: totalCost },
            forecast: { value: forecast },
            totalCostChart: { data: totalCostDetails },
            servicesUsage: [newUsageData],
            costlyTransfers: historyData,
            loading: false,
          },
        })
      })
      .catch(() => {
        this.setState({
          ...this.state,
          overview: {
            ...this.state.overview,
            computeCost: { error: true },
            storageCost: { error: true },
            totalCost: { error: true },
            forecast: { error: true },
            totalCostChart: { error: true },
          },
        })
      })
  }

  loadS3 = (selectedCloud, month) => {
    this.setState({
      ...this.state,
      s3: {
        ...this.state.s3,
        loading: true,
      },
    })
    CloudFlyerAPI.analytics
      .overview(selectedCloud, month)
      .then(overviewResp => {
        const overviewData = overviewResp.data
        let s3, efs, transfer

        if (overviewData.categories) {
          transfer = overviewData.categories.filter(
            cat => cat.name === 'Transfer'
          )[0]
          const storage = overviewData.categories.filter(
            cat => cat.name === 'Storage'
          )[0]

          if (storage && storage.products) {
            efs = storage.products.filter(p => p.label === 'EFS')[0]
            s3 = storage.products.filter(cat => cat.label === 'S3')[0]
          }
        }

        this.setState({
          ...this.state,
          s3: {
            ...this.state.s3,
            loading: false,
            error: false,
            s3: { size: s3.size, cost: s3.monthly_actual },
            efs: { size: efs.size, cost: efs.monthly_actual },
            transfer: { size: transfer.size, cost: transfer.monthly_actual },
          },
        })
      })
      .catch(() => {
        this.setState({
          ...this.state,
          s3: {
            ...this.state.s3,
            loading: false,
            error: true,
            s3: { size: null, cost: null },
            efs: { size: null, cost: null },
            transfer: { size: null, cost: null },
          },
        })
      })
  }

  loadDatabase = (selectedCloud, month) => {
    this.setState({
      ...this.state,
      database: {
        ...this.state.database,
        loading: true,
      },
    })

    Promise.all([
      CloudFlyerAPI.analytics.overview(selectedCloud, month),
      CloudFlyerAPI.analytics.product(selectedCloud, 'database'),
    ])
      .then(([overviewResp, productResp]) => {
        const overviewData = overviewResp.data
        let database, running, stopped

        if (overviewData.categories) {
          database = overviewData.categories.filter(
            cat => cat.name === 'Database'
          )[0]
        }

        const productData = productResp.data

        if (productData && productData.instances) {
          running = productData.instances.filter(
            item => item.state === 'available'
          ).length

          stopped = productData.instances.filter(
            item => item.state !== 'available'
          ).length
        }

        this.setState({
          ...this.state,
          database: {
            ...this.state.database,
            loading: false,
            error: false,
            total: {
              size: database.size,
              cost: database.monthly_actual,
            },
            running,
            stopped,
          },
        })
      })
      .catch(() => {
        this.setState({
          ...this.state,
          database: {
            ...this.state.database,
            loading: false,
            error: true,
            total: {
              size: null,
              cost: null,
            },
            running: null,
            stopped: null,
          },
        })
      })
  }

  loadCompute = (selectedCloud, month) => {
    this.setState({
      ...this.state,
      compute: {
        ...this.state.compute,
        loading: true,
      },
    })

    Promise.all([
      CloudFlyerAPI.analytics.overview(selectedCloud, month),
      CloudFlyerAPI.analytics.product(selectedCloud, 'compute'),
    ])
      .then(([overviewResp, productResp]) => {
        const overviewData = overviewResp.data
        let compute, running, stopped

        if (overviewData.categories) {
          compute = overviewData.categories.filter(
            cat => cat.name === 'Compute'
          )[0]
        }

        const productData = productResp.data

        if (productData && productData.instances) {
          running = productData.instances.filter(
            item => item.state === 'running'
          ).length

          stopped = productData.instances.filter(
            item => item.state !== 'running'
          ).length
        }

        this.setState({
          ...this.state,
          compute: {
            ...this.state.compute,
            loading: false,
            error: false,
            total: {
              size: compute.size,
              cost: compute.monthly_actual,
            },
            running,
            stopped,
          },
        })
      })
      .catch(() => {
        this.setState({
          ...this.state,
          compute: {
            ...this.state.compute,
            loading: false,
            error: true,
            total: {
              size: null,
              cost: null,
            },
            running: null,
            stopped: null,
          },
        })
      })
  }

  loadData = () => {
    const { clouds } = this.props
    const { selectedDate, page } = this.state
    const selectedCloud = this.state.selectedCloud
      ? this.state.selectedCloud
      : this.firstCloud(clouds)
    this.setState({
      ...this.state,
      overview: {
        ...this.state.overview,
        loading: true,
      },
    })
    if (selectedCloud && selectedDate.year && selectedDate.month) {
      const month = new Date(
        selectedDate.year,
        selectedDate.month - 1,
        1,
        1,
        0,
        0,
        0
      ).toISOString()
      switch (page) {
        case 'overview':
          this.loadOverviewData(selectedCloud, month)
          break
        case 's3':
          this.loadS3(selectedCloud, month)
          break
        case 'database':
          this.loadDatabase(selectedCloud, month)
          break
        case 'compute':
          this.loadCompute(selectedCloud, month)
          break
      }
    }
  }

  onCloudSelection = cloudId => {
    const billingBucket = this.props.clouds.filter(c => c.id === cloudId)[0][
      'billing_bucket'
    ]
    this.setState({ selectedCloud: cloudId, billingBucket }, this.loadData)
  }

  onDateChange = ({ type, value }) => {
    this.setState(
      {
        ...this.state,
        selectedDate: { ...this.state.selectedDate, [type]: value },
      },
      this.loadData
    )
  }

  onClearFilter = () => {
    this.setState({
      selectedCloud: null,
      selectedDate: {
        year: null,
        month: null,
      },
    })
  }

  onNavigate = newPage => {
    this.setState({ page: newPage }, this.loadData)
  }

  firstCloud = clouds => {
    const filtered = clouds.filter(
      acc => acc.account_type_id !== 'wasabi' && acc.account_type_id !== 'azure'
    )
    if (filtered && filtered[0]) return filtered[0].id
  }

  render() {
    const {
      selectedDate,
      page,
      overview,
      s3,
      database,
      compute,
      downloadInvoice,
    } = this.state

    const { clouds, data } = this.props

    const selectedCloud = this.state.selectedCloud
      ? this.state.selectedCloud
      : this.firstCloud(clouds)

    const billingBucket =
      selectedCloud &&
      clouds.filter(c => c.id === selectedCloud)[0]['billing_bucket']

    const pricingModal = (
      <PricingModal
        productName="Analytics"
        product="analytics"
        monthlyPricing={20}
        annuallyPricing={199}
        onClose={() => {}}
      />
    )

    return !this.hasAccess ? (
      pricingModal
    ) : (
      <div className="analytics">
        <Filter
          cloudAccounts={clouds}
          onCloudSelection={this.onCloudSelection}
          onDateChange={this.onDateChange}
          selectedCloud={selectedCloud}
          selectedDate={selectedDate}
          onClearFilter={this.onClearFilter}
        />
        <Pages current={page} onChange={this.onNavigate}>
          <Page name="overview" title="Overview">
            <Overview
              loading={overview.loading}
              computeCost={overview.computeCost}
              storageCost={overview.storageCost}
              totalCost={overview.totalCost}
              forecast={overview.forecast}
              totalCostChart={overview.totalCostChart}
              servicesUsage={overview.servicesUsage}
              costlyTransfers={overview.costlyTransfers}
            />
          </Page>
          <Page name="s3" title="Storage">
            <S3
              selectedCloud={selectedCloud}
              loading={s3.loading}
              error={s3.error}
              s3={s3.s3}
              efs={s3.efs}
              transfer={s3.transfer}
            />
          </Page>
          <Page name="database" title="Database">
            <Database
              selectedCloud={selectedCloud}
              loading={database.loading}
              error={database.error}
              total={database.total}
              running={database.running}
              stopped={database.stopped}
            />
          </Page>
          <Page name="compute" title="Compute">
            <Compute
              selectedCloud={selectedCloud}
              loading={compute.loading}
              error={compute.error}
              total={compute.total}
              running={compute.running}
              stopped={compute.stopped}
            />
          </Page>
          <Page name="download-invoice" title="Invoices">
            <DownloadInvoice
              selectedCloud={selectedCloud}
              billingBucket={billingBucket}
              loading={downloadInvoice.loading}
            />
          </Page>
        </Pages>
      </div>
    )
  }
}

const Pages = ({ current, onChange, children }) => {
  let child, activeName
  let links = {}
  React.Children.forEach(children, page => {
    if (!React.isValidElement(page)) return
    const { name, title } = page.props
    links[name] = title
    if (name === current) {
      child = page
      activeName = name
    }
  })

  return (
    <div className="pages">
      <PagesLinks namesTitles={links} onChange={onChange} active={activeName} />
      <hr className="pages-hr" />
      <div className="pages-content">{child}</div>
    </div>
  )
}

const PagesLinks = ({ namesTitles, onChange, active }) => (
  <div className="pages-links">
    {Object.entries(namesTitles).map(([name, title]) => (
      <a
        key={name}
        className={active === name ? 'item item-active' : 'item'}
        onClick={() => onChange(name)}
      >
        {title}
      </a>
    ))}
  </div>
)

const Page = ({ name, children }) => (
  <div key={name} className="page">
    {children}
  </div>
)

export default withRouter(
  connect(
    state => ({
      user: ((state || {}).auth || {}).user,
      clouds: ((state || {}).cloudAccounts || []).items || [],
    }),
    dispatch =>
      bindActionCreators(
        {
          fetchCloudAccounts,
          dispatch,
        },
        dispatch
      )
  )(Analytics)
)
